export const MuiModal = {
  styleOverrides: {
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
};
